<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Analítica desglosada de buses por día
            </div>
            <div class="card-body">
                <div>
                    <div class="d-flex justify-content-between mb-4">
                        <analytics-bus-companies-filter :trigger="triggerSearch" />
                    </div>
                    <table  class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Compañía de bus">Compañía de bus</th>
                                <th scope="col" title="Día">Día</th>
                                <th scope="col" title="Excursión">Excursión</th>
                                <th scope="col" title="Nombre bus">Nombre bus</th>
                                <th scope="col" title="Tipo">Tipología excursión</th>
                                <th scope="col" title="Guía">Guía</th>
                                <th scope="col" title="Tamaño bus">Tamaño bus</th>
                                <th scope="col" title="Precio">Precio</th>
                                <th scope="col" title="Tarifa bus">Tarifa bus</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="analyticsBusCompaniesBreakdown.length == 0">
                                <td colspan="8">
                                    No hay resultados para los datos introducidos
                                </td>
                            </tr>
                            <analytics-bus-companies-breakdown-table-row
                                v-else
                                v-for="(entry, idx) in analyticsBusCompaniesBreakdown"
                                :key="entry.id"
                                :row="entry"
                                :all="analyticsBusCompaniesBreakdown"
                                :idx="idx"
                            />
                            
                        </tbody>
                        <tfoot>
                            <tr style="border-top: 1px solid gray;" >
                                <td colspan="5"></td>
                                <td></td>
                                <td class="text-capitalize font-weight-bold float-right" style="padding-top: 10px;">Total</td>
                                <td class="text-capitalize font-weight-bold text-right" style="padding-top: 10px;">{{total}}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */
import AnalyticsBusCompaniesBreakdownTableRow from './AnalyticsBusCompaniesBreakdownTableRow.vue'
import AnalyticsBusCompaniesFilter from '../BusCompaniesBreakdown/AnalyticsBusCompaniesFilter.vue'
import { mapGetters } from "vuex";

export default {
    components: {
        AnalyticsBusCompaniesBreakdownTableRow,
        AnalyticsBusCompaniesFilter
    },
    data: function () {
        return {
            analyticsBusCompaniesBreakdown: []
        }
    },
    methods: {
        async triggerSearch() {
            // get filter from store
            const filter = this.busCompaniesAnalyticsFilter
            if (filter.day_init != null && filter.day_end != null) {
                this.analyticsBusCompaniesBreakdown = await this.$store.dispatch("analytics/retrieveBreakdownBusCompanies", filter)
                if ( this.analyticsBusCompaniesBreakdown.length == 0 ) {
                    this.$notify({
                        group: "foo",
                        title: "No hay resultados",
                        text: "No hay resultados para los parámetros de filtrado",
                        type: "warning",
                    });
                }
            } else {
                this.$notify({
                    group: "foo",
                    title: "Seleccionar los parámetros",
                    text: "Es necesario seleccionar como mínimo el rango de fechas de la barra de búsqueda",
                    type: "error",
                });
            }
        },
    },
    computed: {
        ...mapGetters(["busCompanies", "busCompaniesAnalyticsFilter"]),
        total() {
            if ( this.analyticsBusCompaniesBreakdown.length > 0 ) {
                let total = this.analyticsBusCompaniesBreakdown.map( (item) => item.price ).filter( (price) => price != null ).reduce((a,b) => b != null && a != null ? parseFloat(a) + parseFloat(b) : 0, 0)
                
                if ( total.toString().includes('.') ) {
                    total = (Math.round(total * 100) / 100)
                    return total.toString().replace('.', ',') + " €"
                }
                return (Math.round(total * 100) / 100) + " €"
            }
        }
    },
}
</script>